<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file ConfirmBuyNow.vue is part of event_pass_client.dev.             -
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - ConfirmBuyNow.vue can not be copied and/or distributed                    -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->

<!--//Created by keni.-->
<!--//User: keni-->
<!--//Date: 01/03/2018-->
<!--//Time: 13:21-->
<!--//Note: Stripe api script must be included in the blade file at top of page-->
<template>

    <div :id="modal_id"
         data-buy-now-modal
         class="modal show fade"
         tabindex="-1"
         role="dialog"
    >
        <div class="modal-dialog modal-dialog-centered"
             role="document"
        >
            <div v-if="display == true" class="modal-content">
                <div class="modal-header"
                     :class="{
                        'bg-primary':!confirmed,
                        'bg-success':confirmed,
                        'bg-info':!available || card_error_vue
                    }"
                >

                    <div class="w-100 d-flex justify-content-between align-items-center">
                        <template v-if="!available">
                            <h5
                                    class="m-0"
                                    v-on:click="viewMyAccount()">
                                Ticket sold out
                            </h5>
                            <div v-on:click="closeModal()"
                                 class="cursor-pointer"
                                 data-dismiss="modal"
                                 aria-label="Close"
                            >
                                <div class="float-right border-0 cursor-pointer">
                                    <i class="icon-180-x-hover material-icons" aria-hidden="true">close</i>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <transition name="slideDown">
                                <h5 v-if="confirmed"
                                    class="m-0"
                                    v-on:click="viewMyAccount()"
                                >Purchase successful</h5>
                                <h5 v-else-if="card_error_vue">Whoops</h5>
                                <h5 v-else class="m-0">Confirm your purchase</h5>
                            </transition>
                            <div v-if="confirmed"
                                 v-on:click="viewMyAccount()"
                                 class="cursor-pointer"
                                 data-dismiss="modal"
                                 aria-label="Close">
                                <i class="icon-scale-hover material-icons" aria-hidden="true">chevron_right</i>
                            </div>
                            <div v-else
                                 v-on:click="closeModal()"
                                 class="cursor-pointer"
                                 data-dismiss="modal"
                                 aria-label="Close"
                            >
                                <div class="float-right border-0 cursor-pointer">
                                    <i class="icon-180-x-hover material-icons" aria-hidden="true">close</i>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="modal-body">
                    <template v-if="!card_error_vue">
                        <div class=" d-flex justify-content-between align-items-start">

                            <div>
                                <div class="h6">
                                    <i class="mr-2"
                                       :class="ticketTypeIconClass(selected_ticket)"
                                    ></i>
                                    <span :class="{
                                'unavailable':!available
                                }">{{lang('title',selected_ticket.ticket_data.lang)}}</span>

                                </div>
                            </div>
                            <div class="fs-4" :class="{
                                'unavailable':!available
                                }">
                                <div v-html="formatMoney(selected_ticket.price)"></div>
                            </div>
                        </div>
                        <div class="mt-1">
                            <p>
                                {{lang('description',selected_ticket.ticket_data.lang).short}}
                            </p>
                        </div>
                    </template>
                    <div v-else="card_error_vue">
                        <p>{{card_error_vue}}</p>
                        <p><small>Please add the ticket to the basket and proceed to the checkout</small></p>
                    </div>
                </div>
                <div class="modal-footer py-0">

                    <!-------------------------------------------------->
                    <!--------------------pay button ------------------->
                    <!-------------------------------------------------->
                    <template v-if="available">
                        <transition name="fade">
                            <template v-if="!card_error_vue">
                                <div v-if="confirmed === false"
                                     class=""
                                >
                                    <div v-if="show_pay_button"
                                            class="btn btn-flat"
                                         v-on:click="userConfirmedPayNow"
                                    >
                                        <div class="mx-auto">Pay now</div>
                                    </div>
                                    <div class="m-1"
                                         v-else>
                                        <CheckoutRequestingSpinner
                                                :show="!show_pay_button"
                                                :width="stripe.progress"
                                        ></CheckoutRequestingSpinner>
                                    </div>

                                </div>
                                <div v-else
                                     class="d-flex justify-content-center align-items-center text-uppercase"
                                >
                                    <a class="btn btn-flat"
                                       :href="my_account_url.data"
                                       v-on:click="viewMyAccount()"
                                    >
                                        View account
                                    </a>
                                </div>
                            </template>
                        </transition>
                    </template>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import lang from '../../../../../app/Shared/Resources/Assets/js/helpers/lang';
    import {format as formatMoney} from '../../../../../app/Shared/Resources/Assets/js/helpers/money';
    import {ticket_types} from '../../../../../app/Shared/Resources/Assets/js/helpers/ticketIcons';
    import {uniqueId} from '../../../../../app/Shared/Resources/Assets/js/helpers/classesAndIds';
    import {checkout} from "../checkout/MixinCheckout";
    import axios from 'axios';
    window.Vue.component('CheckoutRequestingSpinner', require('./../checkout/CheckoutRequestingSpinner'));
    let stripe = null;

    if (typeof Stripe !== 'undefined' && Stripe !== null) {
        stripe = Stripe(Window.StripeApiConfig.pk);
    }

    export default {
        name: "confirm-buy-now",
        components: {},
        props: {

            selected_ticket: Object,
            pay_with_card_url: Object,
            my_account_url: Object,
            payment_intent_request: {
                type: String,
                default: null
            },
            user: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            /**
             *
             * @param {String} stripe_use.payment_intent_request.data   the url
             * @param {Object} stripe_use.payment_intent_request        used to request a charge for the intent
             * @param {String} stripe_use.create_payment_intent.data    the url
             * @param {Object} stripe_use.create_payment_intent         used to request an intent for the saved card
             * @param stripe_use
             */
            stripe_use: {
                type: Object,
                default: null
            }
        },
        mixins: [checkout],
        created() {
        },
        destroyed() {
        },
        mounted() {
            let self = this;

            self.csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        },
        data() {
            return {
                modal_id: uniqueId(),
                display: false,
                confirmed: false,
                available: false,
                stock_check_response: null,
                csrf: null,
                show_pay_button:true,
            }
        },
        methods: {
            viewMyAccount() {
                window.location.href = this.my_account_url.data;
            },
            /**
             * On cancellation the modal will close and trigger to parent that it has been closed
             */
            closeModal() {
                this.confirmed = false;
                this.show_pay_button = true;
                this.$emit('confirm_buy', {
                    action: 'cancel'
                });
                $('#' + this.modal_id).modal({
                    show: false
                });
            },
            checkStock() {
                let self = this;
                self.initStripe('saved_card', self.$refs['saved_card'], stripe);
                self.initPaymentStatus();
                self.$nextTick(function () {
                    self.setProgress(true);

                    /**
                     * Check if ticket is available to purchase and add to a one off basket
                     */
                    axios.post(self.stripe_use.create_payment_intent.data, {
                        one_click: true,
                        ticket_id: self.selected_ticket.id
                    })

                        .then(
                            /**
                             * Make the request for a payment intent
                             *  @param response.data.requires_confirmation
                             *  @param response.data.success
                             *  @param response.data
                             *  @param response
                             */
                            (response) => {
                                if (response.data.success === 'false') {
                                    if (response.data.details.type === 'sold_out') {
                                        self.available = false;
                                    }
                                } else if (response.data.requires_action || response.data.hasOwnProperty('requires_confirmation') || response.data.hasOwnProperty('success')) {
                                    // console.log('requires confirmation triggered');
                                    self.setProgress(true);

                                    self.stock_check = response;
                                } else {
                                    throw response;
                                }
                            })
                        .catch(error => {
                            self.setError(error);
                        })
                        .finally(function () {
                            $('#' + self.modal_id).modal({
                                show: true,
                                backdrop: 'static',
                                keyboard: false
                            });
                        })
                });
            },
            makeTransaction(response) {
                let self = this;
                if (response.data.requires_action) {
                    self.handleCardActionResponse(response, false)
                        .then(function (result) {
                            self.processStripeCardAction(result)
                                .then(() => {
                                    console.log(' self.checkout_pay_url processStripeCardAction response', result)
                                    // self.makeRequest(self.setProgress(true), self.checkout_pay_url, self.$refs.form.getElementsByTagName('input'));
                                })
                                .catch(function (error) {
                                    console.error(error)
                                });
                        })
                        .catch(function (error) {
                            console.error(error)
                        });
                } else if (response.data.hasOwnProperty('requires_confirmation')) {
                    self.setProgress(true);

                    self.handleCardActionResponse(response, true)
                        .then(function (result) {
                            self.processStripeCardAction(result)
                                .then(() => {
                                    if (result.hasOwnProperty('paymentIntent')) {
                                        if (result.paymentIntent.status === 'succeeded') {

                                            let axios_data = {
                                                payment_intent_id: result.paymentIntent.id,
                                                stripePaymentMethodId:result.paymentIntent.payment_method,
                                                user_id: self.user.id
                                            };

                                            axios.defaults.headers.common = {
                                                'X-Requested-With': 'XMLHttpRequest',
                                                'X-CSRF-TOKEN': self.csrf
                                            };

                                            axios
                                                .post(self.payment_intent_request, axios_data)
                                                /**
                                                 * @param {Object} response
                                                 */
                                                .then(function (response) {
                                                    if (response.data.hasOwnProperty('success') && response.data.success === true) {
                                                        self.purchaseSuccessful();
                                                    } else {
                                                        throw 'Not processed'
                                                    }
                                                })
                                                .catch(function (e) {
                                                    // catch error if any
                                                    console.error('events fetch', e);
                                                })
                                                .then(function () {
                                                    // always executed
                                                });
                                            // self.purchaseSuccessful();
                                        }
                                    } else if (result.data.hasOwnProperty('success')) {
                                        self.purchaseSuccessful();
                                    } else {
                                        throw 'Not processed'
                                    }
                                })
                                .catch(function (error) {
                                    self.setError(error);
                                });
                        })
                        .catch(function (error) {
                            console.error(error)
                        });
                } else if (response.data.hasOwnProperty('success')) {
                    console.log('success', response.data)
                    self.purchaseSuccessful();
                }
            },
            purchaseSuccessful() {
                let self = this;

                self.confirmed = true;
                self.checkout_active = false;
                self.stripe.progress = 100;
            },
            userConfirmedPayNow() {
                let self = this;
                self.show_pay_button = false;

                self.makeTransaction(self.stock_check);
            },
            formatMoney(price) {
                return formatMoney(price, {
                    code: $('body').data('currency')
                });
            },
            ticketTypeIconClass(ticket) {
                // console.log('ticket',ticket);
                return ticket_types(ticket.ticket_type, false);
            },
            lang(path, object) {
                // console.log('object',object);
                return lang(path, object)
            },
        },
        computed: {},
        watch: {
            /**
             * When this changes show the modal
             * Run a test to initialise the basket
             * @param ticket
             */
            selected_ticket(ticket) {
                this.stock_check_response = null;
                this.display = ticket != null;
                this.available = true;
                if (this.display === true) {
                    this.checkStock();
                } else {
                    $('#' + this.modal_id).modal({
                        show: false
                    });
                }
            }
        }
    }
</script>

<style scoped>
    .unavailable {
        text-decoration: line-through;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/modals/ConfirmBuyNow.vue